import { render, staticRenderFns } from "./TableTelefonesClientes.vue?vue&type=template&id=3247b087"
import script from "./TableTelefonesClientes.vue?vue&type=script&lang=js"
export * from "./TableTelefonesClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports